export const translationLivechat_sv_case = {
  livechatCaseCreate: "Skapa ärende",
  livechatCaseDialogTitle: "Skapa ärende",
  livechatCaseDialogDescription:
    "Skickar den här chatten via e-post, på samma sätt som det valda kontaktformuläret skickar en förfrågan.",
  livechatCaseTopic: "Ämne",
  livechatCaseTopicPlaceholder: "Välj ett ämne",
  livechatCaseNote: "Anteckning till ärendet (valfritt)",
  livechatCaseNotePlaceholder: "Vad ska hända med ärendet?",
  livechatCaseIncludesTranscript: "Chattens konversation skickas med i ärendet.",
  livechatCaseSubmit: "Skapa ärende",
  livechatCaseSubmitting: "Skapar ärende...",
  livechatCaseCancel: "Avbryt",
  livechatCaseCreated: "Ärende skapat",
  livechatCaseCreatedDescription: "Skickat till {recipient}",
  livechatCaseFailed: "Ärendet kunde inte skapas. Försök igen.",
};
